const API_CONFIG = {
    BASE_URL: 'https://giamsatdubaotainguyennuoc.wri.vn/api/',
    URL_GET_FILE: 'https://giamsatdubaotainguyennuoc.wri.vn/api/file',
    auth: {
        login: 'login',
        changePass: 'user-password'
    },
    user: {
        index: 'user',
        detail: 'user/:id',
        profile: 'profile',
        user: 'user-info',
        functions: 'user-functions',
        audit: 'audit',
    },
    group: {
        index: 'group',
        detail: 'group/:id',
        user: 'user'
    },
    mapLayer: {
        tree: 'map-layer-tree',
        index: 'map-layer',
        detail: 'map-layer/:id',
        file: 'map-layer/:id/file',
        downloadFile: 'map-layer/:id/download-file',
        pointDetail: 'map-layer/:id/point-detail'
    },
    post: {
        index: 'post',
        detail: 'post/:id'
    },
    tool: {
        index: 'tool',
        detail: 'tool/:id'
    },
    report: {
        index: 'report',
        detail: 'report/:id'
    },
    file: {
        upload: 'upload',
        download: 'download'
    },
    point: {
        index: 'point',
        detail: 'point/:id',
        export: 'point/export',
        import: 'point/import'
    },
    pointGroup: {
        index: 'point-group',
        detail: 'point-group/:id'
    },
    data: {
        index: 'data',
        detail: 'data/:id',
        upload: 'data-upload',
        dataType: 'data-type'
    },
    photo: {
        index: 'photo',
        detail: 'photo/:id'
    },
    config: {
        index: 'config',
        detail: 'config/:id'
    },
    statistic: {
        byHour: 'statistic-by-hour',
        byDay: 'statistic-by-day',
        byDate: 'statistic-by-date',
        flex: 'statistic-flex'
    },
    feedback: {
        index: 'feedback',
        detail: 'feedback/:id'
    },
    news: {
        index: 'news',
        detail: 'news/:id',
        analyze: 'view-statistic',
        view: 'view',
        document: 'document',
        documentById: 'document/:id'
    },
};

export default API_CONFIG;
